import React from "react"
import { ListItemData } from "../../../types/listItems"
import ListItem from "./components/ListItem/ListItem"

type Props = {
  listItems: ListItemData[]
}

const List = ({ listItems }: Props) => (
  <ul className="flex flex-row list-none h-full sm:gap-2 md:gap-0">
    {listItems.map((item, i, arr) => (
      <ListItem isLast={i === arr.length - 1} key={i} section={item.section}>
        {item.label}
      </ListItem>
    ))}
  </ul>
)

export default List
